import { ChangeEvent, useRef, useState } from 'react';
import {
  MdOutlineDelete,
  MdOutlinePictureAsPdf,
  MdOutlineUploadFile,
} from 'react-icons/md';
import { Button, Text } from 'components';
import { FontSize, FontWeight } from 'commons';
import * as S from './styles';

interface UploadFileButtonProps {
  handleAddFile: (file: File) => void;
  handleRemoveFile: () => void;
  required?: boolean;
}

export function UploadFileButton({
  handleAddFile,
  handleRemoveFile,
  required,
}: UploadFileButtonProps) {
  const hiddenFileInput = useRef<HTMLInputElement>(null);

  const [fileError, setFileError] = useState(false);
  const [file, setFile] = useState<File | undefined>(undefined);

  function handleClick() {
    if (!hiddenFileInput.current) return;
    hiddenFileInput.current.click();
  }

  function handleChange(event: ChangeEvent<HTMLInputElement>) {
    if (!event.target.files) return;
    setFileError(false);

    const fileUploaded = event.target.files[0];
    const validFileTypes = [
      'application/pdf',
      'image/png',
      'image/jpg',
      'image/jpeg',
    ];

    if (!validFileTypes.includes(fileUploaded.type)) {
      setFileError(true);
      return;
    }

    setFile(fileUploaded);
    handleAddFile(fileUploaded);
  }

  function removeFile() {
    if (!hiddenFileInput.current) return;
    hiddenFileInput.current.value = '';
    setFile(undefined);
    handleRemoveFile();
  }

  return (
    <S.Wrapper>
      <Button onClick={() => handleClick()} full>
        <MdOutlineUploadFile size={18} />
        Anexar NF de devolução {required && '*'}
      </Button>
      <input
        type="file"
        ref={hiddenFileInput}
        onChange={handleChange}
        hidden
        accept="image/*,.pdf"
      />
      <S.FileFeedback>
        <Text size={FontSize.font10} weight={FontWeight.bold}>
          Arquivos em PNG, JPG, PDF
        </Text>
        {fileError && (
          <S.FileError>Carregamento falhou: Formato inválido</S.FileError>
        )}
      </S.FileFeedback>

      {file && (
        <S.FileInfo>
          <Text>
            <MdOutlinePictureAsPdf size={18} />
            {file.name}
          </Text>
          <S.RemoveFile onClick={removeFile}>
            <MdOutlineDelete size={18} />
          </S.RemoveFile>
        </S.FileInfo>
      )}
    </S.Wrapper>
  );
}
